<template>
  <form @submit.prevent="submit" class="community-comments-form">
    <h5 class="text-center mb-4">
      <template v-if="!hasParent">Criar tópico</template>
      <template v-else>Responder</template>
    </h5>

    <form-group
      v-if="!hasParent"
      v-model="form.category_id"
      :errors="errors.category_id"
      id="category_id"
      placeholder="Tópico"
      el-select
      :options="categories"
    />
    <form-group
      v-if="!hasParent"
      v-model="form.title"
      :errors="errors.title"
      id="title"
      placeholder="Título"
    />
    <form-group
      v-model="form.text"
      :errors="errors.text"
      id="text"
      placeholder="Digite um texto..."
      required
      textarea
    />
    <image-input v-if="!hasParent" @pick="pickFile" :url="photo" />
    <form-group
      v-if="!hasParent"
      v-model="form.lesson_id"
      :errors="errors.lesson_id"
      id="lesson_id"
      label="Vincular postagem a uma aula"
      placeholder="Aula"
      el-select
      :options="lessons"
      nullable
    />

    <div class="d-flex justify-content-end">
      <button
        class="btn btn-primary btn-strong px-5 rounded-pill"
        :disabled="loading"
      >
        <loading :show="loading">
          Publicar
        </loading>
      </button>
    </div>
  </form>
</template>

<script>
import ImageInput from "@/components/community/ImageInput";
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";
import { get } from "lodash";

export default {
  components: { ImageInput },
  props: {
    parent: Object,
    comment: Object
  },
  data() {
    const comment = this.comment;
    if (comment) {
      comment.lesson_id = parseInt(comment.lesson_id);
      comment.category_id = parseInt(comment.category_id);
    }
    return {
      newPhoto: false,
      photo: get(this.comment, "picture"),
      ...formFields(["text", "title", "category_id", "lesson_id"], comment)
    };
  },
  computed: {
    ...mapState("courses", ["categories", "feed"]),
    hasParent() {
      return this.parent || get(this.comment, "parent");
    },
    lessons() {
      return this.feed.reduce(
        (prev, cur) => [
          ...prev,
          ...cur.lessons.map(lesson => ({
            id: lesson.id,
            name: lesson.full_title
          }))
        ],
        []
      );
    }
  },
  methods: {
    pickFile(file) {
      this.newPhoto = true;
      this.photo = file;
    },
    submit() {
      if (this.loading) return;
      this.loading = true;

      const data = { ...this.form };
      if (this.parent) {
        data.parent = this.parent.id;
        data.title = this.parent.title;
        data.category_id = this.parent.category_id;
      }

      if (this.newPhoto) {
        data.picture = this.photo;
      }

      if (!data.lesson_id) {
        data.lesson_id = null;
      }

      let action = "community/add";
      if (this.comment) {
        action = "community/update";
        data.id = this.comment.id;
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.text = "";
          this.$message.success("Comentário salvo com sucesso");
          this.$emit("success");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-comments-form {
  textarea {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
    border: none;
    color: white;
  }
}
</style>
